module.exports = __webpack_public_path__ + "static/media/logoListaAImprimibles.a229011f.svg";